// TODO: MEOW-3603 Make this handle more Card cases
import type { BoxProps } from '@hover/blueprint';
import { Box, useTheme } from '@hover/blueprint';
import React from 'react';

import { pickForegroundColor } from '../../helpers/color';

export const CARD_PADDING = 500;

export interface BasicCardProps extends BoxProps {
  backgroundColorProp?: string;
  hasShadow?: boolean;
}

// Cards all share logic for text color on background color
// as well as border radius
export const BasicCard = ({
  backgroundColorProp,
  children,
  hasShadow,
  ...props
}: BasicCardProps) => {
  const { colors } = useTheme();
  const backgroundColor = backgroundColorProp || colors.neutral[0];

  const { color: textColor } = pickForegroundColor(
    backgroundColor,
    colors.neutral[0],
    colors.neutral[900],
  );

  return (
    <Box
      backgroundColor={backgroundColor}
      bgSize="cover"
      borderRadius={400}
      color={textColor}
      flexDirection="column"
      height="100%"
      overflow="hidden"
      shadow={hasShadow ? 'distance400' : ''}
      width="100%"
      {...props}
    >
      {children}
    </Box>
  );
};
